import { MdDialog, MdDialogRef } from '@angular/material';
import { AppMessage } from './../../../Common/appMessage';
import { Utility } from './../../../Common/Services/utility';
import { AdmBlacklistExamService } from './adm-blacklist-exam.service';
var AdmBlacklistExamComponent = (function () {
    function AdmBlacklistExamComponent(dialogRef, data, _blackListService, _utility, _dialog, _appMessage) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._blackListService = _blackListService;
        this._utility = _utility;
        this._dialog = _dialog;
        this._appMessage = _appMessage;
        this.locationId = data;
    }
    AdmBlacklistExamComponent.prototype.ngOnInit = function () {
        this.formattedExamData = [];
        this.selectedChar = '#';
        this.alphabets = [];
        this.alphabets.push('#'); // First char is #
        this.undoAllExamisBlacklisted = false;
        this.doAllExamisBlacklisted = false;
        this.isSelectExam = false;
        /**
         * push characters into array
         * Get all chars from its char code
         */
        for (var i = 65; i <= 90; i++) {
            this.alphabets.push(String.fromCharCode(i));
        }
        this.getBlackListExam();
    };
    AdmBlacklistExamComponent.prototype.getBlackListExam = function () {
        var _this = this;
        this._utility.addLoaderCount();
        this._blackListService.getExamList(this.locationId).subscribe(function (response) {
            _this._utility.onSuccessCallback(response, null, function () {
                _this.examData = response.response.results;
                _this.getFormattedExamData();
            });
        }, function (error) { return _this._utility.onErrorCallback(error); });
    };
    /**
     * This function return formatted data which we have required to create dyanamic layout
     * Design > [{label: 'A', data: [{examCode: 101, examName: 'testexam', isBlacklisted : true}]}]
     */
    AdmBlacklistExamComponent.prototype.getFormattedExamData = function () {
        var _loop_1 = function (i) {
            var item = this_1.examData[i];
            var examName = item.examName;
            var firstChar = examName.substring(0, 1).toUpperCase();
            var labels = this_1.formattedExamData.map(function (item) { return item.label; });
            /**
             * If Char Label already exist in array then only Push exam data
             * Else create a new Label and then push exam data into Data object of formattedExamData array
             */
            if (labels.indexOf(firstChar) > -1) {
                var specificItem = this_1.formattedExamData.find(function (item) { if (item.label == firstChar)
                    return item; });
                specificItem.data.push({ 'examId': item.examId, 'examName': examName, 'isBlacklisted': item.isBlacklisted });
            }
            else {
                this_1.formattedExamData.push({ 'label': firstChar, 'data': [{ 'examId': item.examId, 'examName': examName, 'isBlacklisted': item.isBlacklisted }] });
            }
        };
        var this_1 = this;
        for (var i = 0; i < this.examData.length; i++) {
            _loop_1(i);
        }
        if (this.formattedExamData && this.formattedExamData.length > 0) {
            this.formattedExamData.sort(function (item1, item2) { if (item1.label > item2.label) {
                return 1;
            }
            else {
                return -1;
            } });
        }
    };
    /**
     * If clicked on select all checkbox then Update isBlacklisted property of examdata true for all records else make it false.
     * @param isChecked : value of select all and  unselect all
     */
    AdmBlacklistExamComponent.prototype.checkedExam = function (isChecked) {
        var data = this.formattedExamData.map(function (item) { return item.data; });
        data.forEach(function (element) {
            if (element && element.length > 0) {
                element.forEach(function (subElement) {
                    subElement.isBlacklisted = isChecked;
                });
            }
        });
    };
    AdmBlacklistExamComponent.prototype.onSelectAll = function (checked) {
        if (checked) {
            this.checkedExam(true);
            this.undoAllExamisBlacklisted = false;
        }
        else {
            this.checkedExam(false);
        }
    };
    AdmBlacklistExamComponent.prototype.onUnSelectAll = function (checked) {
        this.checkedExam(false);
        this.doAllExamisBlacklisted = false;
    };
    AdmBlacklistExamComponent.prototype.onUpdate = function () {
        var _this = this;
        var instance = this._dialog.openDialogs[0];
        this._dialog.openDialogs.pop(); //to clear instance of first dialog box to opne another on it(issue i IE,edge and safari) 
        var blacklistExams = [];
        for (var i = 0; i < this.formattedExamData.length; i++) {
            var item = this.formattedExamData[i];
            if (item.data.length > 0) {
                for (var j = 0; j < item.data.length; j++) {
                    var examObj = item.data[j];
                    blacklistExams.push({ examId: examObj.examId, isBlacklisted: examObj.isBlacklisted });
                }
            }
        }
        var params = {
            locationId: Number(this.locationId),
            blacklistExams: blacklistExams
        };
        this._blackListService.updateBlacklistExam(params).subscribe(function (response) {
            _this._utility.onSuccessCallback(response, _this._appMessage.getItem['UMsg00029'], function () {
                _this.closeDialog();
            });
        }, function (error) { _this.closeDialog(); _this._utility.onErrorCallback(error); });
        this._dialog.openDialogs.push(instance); //popped instance pushed again to maintain its normal behavior
    };
    // To close the current dialog
    AdmBlacklistExamComponent.prototype.closeDialog = function (dialogResult) {
        if (dialogResult === void 0) { dialogResult = 0; }
        this.dialogRef.close(dialogResult);
    };
    return AdmBlacklistExamComponent;
}());
export { AdmBlacklistExamComponent };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-blacklist-exam/adm-blacklist-exam.component.ts.pre-build-optimizer.js